module.exports = __webpack_public_path__ + "0719d6de2ee7dffb92cb9a257252ce2d.png";